(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('.shopify-section.section-header gaia-header');

    function setHeaderHeight() {
      let headerHeight = header ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--header-height', `${parseInt(headerHeight)}px`);
    }

    setHeaderHeight();

    var headerObserver = new ResizeObserver(setHeaderHeight);
    if (header) headerObserver.observe(header);
  });

  } catch(e) { console.error(e); }
})();
})();
